import React from "react";
import Fixedbg from "@/components/UserView/FixedBaground/Fixedbg";
import Header from '@/components/UserView/Header/header';
import { Link } from "react-router-dom";
import '@/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Footer from "../Footer/footer";
import Header4 from "../Header4/header4";

const Home = () =>{

    const token = localStorage.getItem("token");

    function menu(){
    if(token === undefined || token === null){
        return(
            <>
            <Header/>
            </>
        )
    }
    else{
        return(
            <>
            <Header4/>
            </>
        )
    }
}


function Register(){
    if(token === undefined || token === null){
        return(
            <>
                <Link to="/register" className="cutom-btn mt-4">Register Now<svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8839 10.8839C11.372 10.3957 11.372 9.60427 10.8839 9.11612L2.92893 1.16117C2.44078 0.67301 1.64932 0.67301 1.16117 1.16117C0.67301 1.64932 0.67301 2.44078 1.16117 2.92893L8.23223 10L1.16117 17.0711C0.67301 17.5592 0.67301 18.3507 1.16117 18.8388C1.64932 19.327 2.44078 19.327 2.92893 18.8388L10.8839 10.8839ZM9 11.25H10V8.75H9V11.25Z" fill="white"/>
                </svg></Link>
            </>
        )
    }
    else{
        return(
            
            <>
                <Link to="/dashboard" className="cutom-btn mt-4">Dashboard<svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8839 10.8839C11.372 10.3957 11.372 9.60427 10.8839 9.11612L2.92893 1.16117C2.44078 0.67301 1.64932 0.67301 1.16117 1.16117C0.67301 1.64932 0.67301 2.44078 1.16117 2.92893L8.23223 10L1.16117 17.0711C0.67301 17.5592 0.67301 18.3507 1.16117 18.8388C1.64932 19.327 2.44078 19.327 2.92893 18.8388L10.8839 10.8839ZM9 11.25H10V8.75H9V11.25Z" fill="white"/>
                </svg></Link>
            </>
            
        )

    }
}


  return(
<>
{menu()}
<div className="container-fluid p-0 home">
    <div className="row container_row">
        <div className="col-lg-5">
        <div className="fixed-bgf">
            <Fixedbg/>
        </div>
        </div>
        <div className="col-lg-7">
            <div className="row">
                <div className="col-lg-7">
                    <section className="find_leaders">
                        <h1 className="mb-5">Find business leaders in the <span className='color-9F7854'><strong> community</strong></span></h1>
                        <h2 className="h3_medum"><strong>Welcome to Khoja Business Directory!</strong></h2>
                        <p>The mission of this platform is to create a directory of all Khoja community-led businesses and help them find other business leaders while keeping data security in mind. KBD is a GDPR compliant and fully moderated platform that requires identity verifications from its users and has end-to-end data encryption to ensure that the data is always in safe hands.</p>
                        <p>KBD is a close-knitted community only for Khoja community members and doesn’t accept any registrations or data requests from anyone else.</p>                       
                        {Register()}
                    </section>
                </div>
            </div>
        </div>

    </div>
    <div className="resposive_footer">
        <Footer/>
    </div>
</div>
</>
  )}
export default Home;